<template>

<div id="slide06" class="section section-white">

  <Subtitle :text="$t('home.slide06.title')"/>

  <Common :text="$t('home.slide06.text')"/>

  <div id="slide06-images">

    <div class="half-block half-block-1">
      <a href="https://aws.amazon.com/education/edstart/" target="_blank">
        <Qimage name="aws.png"/>
      </a>
    </div>

    <div class="half-block half-block-2">
      <a href="https://kinequo.com/" target="_blank">
        <Qimage name="knq.png"/>
      </a>
    </div>

  </div>

</div>

</template>

<script>
import Subtitle from '../general/texts/Subtitle.vue'
import Common from '../general/texts/Common.vue'
import Qimage from '../general/elements/Qimage.vue'

export default {
  name: 'Slide06',
  components: {
    Subtitle,
    Common,
    Qimage
  }
}
</script>

<style lang="scss" scoped>
.half-block {
  text-align: center;
  margin-top: 50px;
}

::v-deep img {
  width: 20%;
}

@media (max-width: 2100px), (max-device-width: 2100px) {
  ::v-deep img {
    width: 30%;
  }
}

@media (max-width: 900px), (max-device-width: 900px) {
  ::v-deep img {
    width: 50%;
  }
}

@media (max-width: 750px), (max-device-width: 750px) {
  ::v-deep img {
    width: 30%;
  }
}

@media (max-width: 600px), (max-device-width: 600px) {
  ::v-deep img {
    width: 50%;
  }
}

@media (max-width: 350px), (max-device-width: 350px) {
  ::v-deep img {
    width: 75%;
  }
}
</style>
